module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAO9JREFUeNpi/P//PwOlgImBCoAFzlrAOBlI5gDxNSDeBMQTgfgFklo2IE4A4hAgtgHiL0AsA8S/WJAUKUJpLSjOB2J/IN4NxKJAvAuIDZDUc0Ix0JAFjHVAxh0srgQp2AjEqkA8E80AGOAH4pOgMFHH411OqAvl8KhRp0rAjhqC2xBQLHwkUe8vIP6LnGKTgdgTiPugcW8JxGloUfsdiJcB8Q4gvg/FOciGgDR9AOKn0KQOSqUO0GQOAsehqdcVargocuJj/D+fIQpIOwHxO2jKvY/kgvVQcRDwA2IJqBpQAhQCYhVQHmIcNEUBQIABAE26L8fR1qepAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/auth/theme.png
// module id = 946
// module chunks = 453